import { AdjustedProductType } from "../interfaces/DTO/mislaka_xml_models";

type LiquidityStockKey = "liquid_stock" | "liquid_nonstock" | "nonliquid_stock" | "nonliquid_nonstock";

type LoanEligibilityByCombination = Record<LiquidityStockKey, number>;

export class LoanEligibilityConfigService {
  static readonly config: Record<AdjustedProductType, LoanEligibilityByCombination> = {
    [AdjustedProductType.EDUCATION_FUND]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.8,
      nonliquid_stock: 0.3,
      nonliquid_nonstock: 0.4,
    },
    [AdjustedProductType.INVESTMENT_PROVIDENT_FUND]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.8,
      nonliquid_stock: 0.4,
      nonliquid_nonstock: 0.5,
    },
    [AdjustedProductType.PROVIDENT_FUND]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.8,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.PURE_SAVINGS_POLICY]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.8,
      nonliquid_stock: 0.6,
      nonliquid_nonstock: 0.8,
    },
    [AdjustedProductType.PENSION_FUND]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.MANDATORY_PENSION_FUND]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.SUPPLEMENTARY_PENSION_FUND]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.BASIC_PENSION_FUND]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    // ברירת מחדל למוצרים אחרים
    [AdjustedProductType.LIFE_INSURANCE_SAVINGS]: {
      liquid_stock: 0.4,
      liquid_nonstock: 0.6,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.PURE_RISK_POLICY]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0,
      nonliquid_nonstock: 0,
    },
    [AdjustedProductType.MORTGAGE_LIFE_INSURANCE]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0,
      nonliquid_nonstock: 0,
    },
    [AdjustedProductType.COLLECTIVE_RISK_POLICY]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0,
      nonliquid_nonstock: 0,
    },
    [AdjustedProductType.CHILD_SAVINGS]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.8,
      nonliquid_stock: 0.4,
      nonliquid_nonstock: 0.5,
    },
    [AdjustedProductType.ACTIVE_MANAGERS_INSURANCE]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.6,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.INACTIVE_MANAGERS_INSURANCE]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.6,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.CAPITAL_PROVIDENT_FUND]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.8,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.PENSION_PROVIDENT_FUND]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.8,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.COMBINED_PROVIDENT_FUND]: {
      liquid_stock: 0.6,
      liquid_nonstock: 0.8,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.OLD_COMPREHENSIVE_PENSION]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
    [AdjustedProductType.OLD_BASIC_PENSION]: {
      liquid_stock: 0,
      liquid_nonstock: 0,
      nonliquid_stock: 0.28,
      nonliquid_nonstock: 0.3,
    },
  };

  static getMaxLoanPercent(type: AdjustedProductType, isLiquid: boolean, isStock: boolean): number {
    const key: LiquidityStockKey =
      isLiquid
        ? (isStock ? "liquid_stock" : "liquid_nonstock")
        : (isStock ? "nonliquid_stock" : "nonliquid_nonstock");

    return this.config[type]?.[key] ?? 0;
  }
}
